var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82019 1.82019C1.50763 2.13275 1.33203 2.55667 1.33203 2.9987V4.66536C1.33203 5.10739 1.50763 5.53131 1.82019 5.84388C2.13275 6.15644 2.55667 6.33203 2.9987 6.33203H4.66536C5.10739 6.33203 5.53131 6.15644 5.84388 5.84388C6.15644 5.53131 6.33203 5.10739 6.33203 4.66536V2.9987C6.33203 2.55667 6.15644 2.13275 5.84388 1.82019C5.53131 1.50763 5.10739 1.33203 4.66536 1.33203H2.9987C2.55667 1.33203 2.13275 1.50763 1.82019 1.82019Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1535 1.82019C9.84096 2.13275 9.66536 2.55667 9.66536 2.9987V4.66536C9.66536 5.10739 9.84096 5.53131 10.1535 5.84388C10.4661 6.15644 10.89 6.33203 11.332 6.33203H12.9987C13.4407 6.33203 13.8646 6.15644 14.1772 5.84388C14.4898 5.53131 14.6654 5.10739 14.6654 4.66536V2.9987C14.6654 2.55667 14.4898 2.13275 14.1772 1.82019C13.8646 1.50763 13.4407 1.33203 12.9987 1.33203H11.332C10.89 1.33203 10.4661 1.50763 10.1535 1.82019Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82019 10.1535C1.50763 10.4661 1.33203 10.89 1.33203 11.332V12.9987C1.33203 13.4407 1.50763 13.8646 1.82019 14.1772C2.13275 14.4898 2.55667 14.6654 2.9987 14.6654H4.66536C5.10739 14.6654 5.53131 14.4898 5.84388 14.1772C6.15644 13.8646 6.33203 13.4407 6.33203 12.9987V11.332C6.33203 10.89 6.15644 10.4661 5.84388 10.1535C5.53131 9.84096 5.10739 9.66536 4.66536 9.66536H2.9987C2.55667 9.66536 2.13275 9.84096 1.82019 10.1535Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1535 10.1535C9.84096 10.4661 9.66536 10.89 9.66536 11.332V12.9987C9.66536 13.4407 9.84096 13.8646 10.1535 14.1772C10.4661 14.4898 10.89 14.6654 11.332 14.6654H12.9987C13.4407 14.6654 13.8646 14.4898 14.1772 14.1772C14.4898 13.8646 14.6654 13.4407 14.6654 12.9987V11.332C14.6654 10.89 14.4898 10.4661 14.1772 10.1535C13.8646 9.84096 13.4407 9.66536 12.9987 9.66536H11.332C10.89 9.66536 10.4661 9.84096 10.1535 10.1535Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.03fb827b3e8113d672af15f0fa87d2c8.svg";
export { ForwardRef as ReactComponent };